import { request } from "@src/utils";
import { SignUpForm, User } from "@src/interfaces";

const createUser = (signUpForm: SignUpForm) => {
  return request.post<User>("/api/user/signup", signUpForm, {});
};

export default createUser;
